import { ComponentType } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Paragraph } from "@tvg/design-system/web";

export const SlotContainer = styled.div`
  position: relative;
  border: var(--fd-border-widths-border-width-010) solid
    var(--fd-colors-border-default);
  border-radius: var(--fd-radii-border-radius-020);
  margin: 0 var(--fd-space-space-2) var(--fd-space-space-4);
  width: 100%;
  box-shadow: var(--fd-shadows-elevations-all-around-low);

  @media only screen and (max-width: 699px) {
    margin: var(--fd-space-space-4) auto 0;
  }

  @media only screen and (min-width: 700px) {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media only screen and (min-width: 600px) and (max-width: 799px) {
    flex-basis: calc((100% - var(--fd-space-space-4)) / 2);

    &:nth-child(odd) {
      margin-left: 0;
    }

    &:nth-child(even) {
      margin-right: 0;
    }
  }

  @media only screen and (min-width: 800px) {
    flex-basis: calc((100% - var(--fd-space-space-8)) / 3);
    max-width: 318px;

    &:nth-child(3n + 1) {
      margin-left: 0;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
`;

export const SlotImageWrapper = styled.div<{ imageUrl?: string }>`
  display: block;
  height: 142px;
  width: 100%;
  background-image: url(${(props) => props.imageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 3px 3px 0 0;
`;

export const SlotCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background: var(--fd-colors-background-surface);
  border-radius: 0 0 var(--fd-radii-border-radius-020)
    var(--fd-radii-border-radius-020);

  @media only screen and (min-width: 835px) {
    height: 100%;
  }

  @media only screen and (min-width: 700px) and (max-width: 834px) {
    height: 210px;
  }
`;

export const SlotCopyContent = styled.div<{ slotImageHeight?: number }>`
  display: block;
  padding: var(--fd-space-space-4);

  @media only screen and (min-width: 600px) {
    height: 146px;
  }
`;

type LinkAttrs = {
  as: string | typeof Link;
  to: string | typeof undefined;
};

// @ts-ignore
export const SlotLink: ComponentType<LinkAttrs> = styled(Link).attrs({})`
  text-decoration: none;
`;

export const SlotMore = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: var(--fd-colors-background-layer);
  width: 100%;
  height: 42px;
  line-height: 42px;
  border-radius: 0 0 var(--fd-border-widths-border-width-010)
    var(--fd-border-widths-border-width-010);
  border-top: var(--fd-border-widths-border-width-010)
    var(--fd-border-styles-border-style-solid-style)
    var(--fd-colors-border-default);
  gap: var(--fd-space-space-2);
`;

export const SlotTitleAndOptinTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: var(--fd-space-space-1);
  align-items: center;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TagContainer = styled.div`
  display: inline-block;
  white-space: nowrap;
  width: fit-content;
`;

export const SlotDescription = styled(Paragraph)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
